import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORY_LABEL, listUrl } from './emp360Shared';

const EST = [
  { k: 'concluido', label: 'Concluídos', cls: 'border-emerald-200 bg-emerald-50 text-emerald-800', status: 'concluido,registado_comercializadora' },
  { k: 'em_curso', label: 'Em curso', cls: 'border-sky-200 bg-sky-50 text-sky-800', status: 'pedido_chamada,validacao_documentos,chamada_efectuada,esclarecimentos,pendente_documentos' },
  { k: 'anulado', label: 'Anulados', cls: 'border-slate-200 bg-slate-50 text-slate-700', status: 'anulado,anulado_comercializadora,baixa' },
];

export const MonthSummary = ({ d, month }) => {
  const m = d.mes_resumo;
  const base = { category: d.empresa.categoria_principal, company: d.empresa.company, month };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="emp360-month-summary">
      <div className="flex flex-wrap items-baseline gap-2">
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F] flex-1">Este mês</h2>
        <Link to={listUrl(base)} className="text-sm text-[#2D3E6F] hover:underline" data-testid="emp360-month-total">{m.total} contrato(s) · ver na listagem</Link>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {EST.map((e) => (
          <Link key={e.k} to={listUrl({ ...base, status: e.status })} data-testid={`emp360-est-${e.k}`}
            className={`rounded-xl border p-3 hover:shadow-sm transition-shadow ${e.cls}`}>
            <div className="text-2xl font-bold font-[Outfit]">{m.estados[e.k] || 0}</div>
            <div className="text-xs">{e.label}{e.k === 'anulado' && m.total ? ` · ${m.anulados_pct}%` : ''}</div>
          </Link>
        ))}
      </div>
      {Object.keys(m.por_categoria).length > 0 && (
        <div className="flex flex-wrap gap-2 text-xs text-slate-600">
          {Object.entries(m.por_categoria).map(([c, n]) => <span key={c} className="px-2 py-0.5 rounded-full bg-slate-100">{CATEGORY_LABEL[c] || c}: {n}</span>)}
        </div>
      )}
      <p className="text-[11px] text-slate-400">Clique num número para abrir a listagem de contratos deste mês.</p>
    </div>
  );
};
